<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Daftar : Deposit">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitDeposit"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>

                <w-dialog
                    v-model="dialog.show"
                    :fullscreen="dialog.fullscreen"
                    :width="dialog.width"
                    :persistent="dialog.persistent"
                    :persistent-no-animation="dialog.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Profil </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialog.valid"
                            @validate="submitProfil"
                            @success="success"
                        >

                            <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            <br>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="ID Pengenalan/No. Syarikat*"
                                    name="ID Pengenalan/No. Syarikat*"
                                    v-model="form_profil.no_id"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_profil.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Alamat"
                                    name="Alamat"
                                    v-model="form_profil.alamat1"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat2"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat3"
                                />
                            </w-flex>
                            <z-lookup
                                label="Poskod"
                                name="poskod"
                                :url="service_deposit + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form_profil.lkp_poskod_id"
                            /><br />
                            <w-flex
                                justify-center
                                align-center
                                v-if="form_profil.bandar"
                            >
                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Bandar :</h5>
                                    {{ form_profil.bandar }}
                                </div>

                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Negeri :</h5>
                                    {{ form_profil.negeri }}
                                </div>
                                <br />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="No. Telefon"
                                    name="No. Telefon"
                                    v-model="form_profil.no_tel"
                                    :validators="[validators.numeric]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Email"
                                    name="Email"
                                    v-model="form_profil.emel"
                                    
                                />
                            </w-flex>
                            
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialog.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialog.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>

                <w-card bg-color="" class="">
                    <h3>Profil</h3>
                    <w-flex class="mt3">
                        <div class="xs11">
                            <!-- <z-lookup 
                          label="Profil *" 
                          name="Profil" 
                          :url='service_deposit+"lookup/profil"'
                          :sort="false" :cache="false" 
                          v-model="form_cari.id"
                          :validators="[validators.required]"/> -->
                            <z-input
                                label="Profil *"
                                name="profil_id"
                                readonly
                                @click="profil"
                                :validators="[validators.required]"
                            />
                        </div>
                        <div class="xs1">
                            <!-- <w-icon>fal fa-search</w-icon> -->
                            &nbsp;
                            <w-icon @click="dialog.show = true"
                                >fal fa-plus</w-icon
                            >
                        </div>
                    </w-flex>
                    <br />

                    <w-flex justify-center align-center v-if="form.no_id">
                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                          Profil :
                      </h5>
                      {{form.no_id.toUpperCase()}} | {{form.nama.toUpperCase()}}
                    </div>

                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                          Alamat :
                        </h5>
                        <span >
                          <template v-if="form.alamat1"> 
                        {{form.alamat1.toUpperCase()}}, 
                      </template>
                       <template v-if="form.alamat2"> 
                        {{form.alamat2.toUpperCase()}}, 
                      </template>
                       <template v-if="form.alamat3"> 
                        {{form.alamat3.toUpperCase()}}, 
                      </template>
                      <template v-if="form.poskod"> 
                        {{form.poskod.toUpperCase()}},
                        </template> 
                        <template v-if="form.bandar"> 
                        {{form.bandar.toUpperCase()}}, 
                      </template>
                      <template v-if="form.negeri"> 
                      {{form.negeri.toUpperCase()}}
                    </template>
                    </span>
                    </div>
              </w-flex> </w-card
                ><br />

                <!-- </w-from> -->
                <w-card bg-color="" class="">
                    <h3>Butiran</h3>
                    <w-flex class="mt3">
                        <div class="xs6">
                            <z-lookup
                                label="Kod Akaun *"
                                name="akaun"
                                :url="service_deposit + 'lookup/akaun_akhir'"
                                :sort="false"
                                :cache="false"
                                @pilih="getJenis(form)"
                                v-model="form.akaun_id"
                                :validators="[validators.required]"
                            />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6">
                            <z-money
                                v-model:originalValue="form.amaun_deposit"
                                label="Amaun Deposit (RM)*"
                                :validators="[validators.required]"
                            ></z-money>

                            <!-- {{form.amaun_deposit}} -->
                        </div>
                    </w-flex>
<!-- belum guna akaun sebenar nya -->
                    <!-- <template v-if="form.akaun_id == 13"> -->
                        <w-flex class="mt3">
                        <div class="xs6">
                               <template v-if="form.lkp_deposit_jenis_id">
                                        <template v-if="form.ind_deposit_jenis_id">
                                           <z-lookup label="Jenis *" name="deposit_jenis" :url='service_deposit+"lookup/deposit_jenis"' :sort="false" :cache="false" v-model="form.lkp_deposit_jenis_id"  />
                                       </template>
                                       <template v-else>
                                           <z-lookup label="Jenis *" name="false" :url='service_deposit+"lookup/deposit_jenis"' :sort="false" :cache="false" v-model="form.lkp_deposit_jenis_id"  />
                                       </template>
                                </template>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                         <!-- <w-radios v-model="form.lkp_deposit_butiran_id" :items="butiranJenis" inline ></w-radios> -->
                        <div class="xs6" v-if="form.lkp_deposit_jenis_id == 1">
                            <z-lookup
                                label="Butiran *"
                                :url="service_deposit + 'lookup/deposit_butiran'"
                                name="Butiran"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_deposit_butiran_id"
                                :validators="[validators.required]"
                            />
                        </div>
                    </w-flex>
                    <!-- </template> -->
                    <!-- <w-form ref="form" v-model="dialog.valid" @validate="muatNaik" @success="success"> -->
                    <w-flex class="mt3">
                        <w-input
                            label="No. Fail *"
                            class="xs3 mr3"
                            placeholder="Cth:040001234"
                            v-model="form.no_fail"
                            :validators="[validators.required]"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <w-input
                            class="xs3 mr3"
                            type="file"
                            placeholder="Sila Muatnaik Dokumen Sokongan"
                            required
                            v-model="files"
                            label="Dokumen Sokongan"
                        />
                    </w-flex>
                    <!-- </w-form> -->

                    <w-flex class="mt3">
                        <w-textarea
                            class="mt3"
                            placeholder="Sila Masukkan Keterangan"
                            label="Keterangan"
                            v-model="form.keterangan"
                            :validators="[validators.required]"
                        />
                    </w-flex>
                </w-card>

                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="form.submitted = form.sent = false"
                    >
                        Reset
                    </w-button>
                    <template v-if="$zutil.can('Deposit Penyediaan')">
                        <template v-if="form.no_id != null">
                            &nbsp;&nbsp;&nbsp;
                            <w-button
                                class="my1"
                                type="submit"
                                :disabled="form.valid === false"
                                :loading="form.submitted && !form.sent"
                            >
                                <w-icon dark tile class="mr2">fal fa-save</w-icon>
                                Simpan
                            </w-button>
                        </template>
                    </template>
                </w-flex>
            </w-form>
            <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama"
                                v-model="carian_profil.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariProfil"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No KP | Nama
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            v-model="form.profil_id"
                                            :return-value="dt.value"
                                            @click="pilihProfil(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
// import moment from 'moment'

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_deposit + "deposit",
            reload: true,
            form_profil: {},
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            form_cari: {},
            form_akaun: {},
        akauns : [],
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Deposit", route: "/deposit" },
                { label: "Daftar ", route: "/deposit/daftar" },
            ],
            files: [],
            carian_profil: { q: "" },
            profils: [],
            butiranJenis: [],
            dialogProfil: {
                  valid: false,
                  show: false,
                  fullscreen: false,
                  persistent: true,
                  persistentNoAnimation: false,
                  loading: false,
                  width: 800,
                  form: {nama: '', email: ''}
                },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                no_tel: "",
                amaun_deposit: 0.0,
            },
             validators: {
                unique: (value) => !!value || "Medan Ini Wajib Isi",
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_deposit +
                        "lookup/lkp_poskod_detail/" +
                        this.form_profil.lkp_poskod_id
                )
                .then((res) => {
                    this.form_profil.negeri = res.negeri;
                    this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                    this.form_profil.bandar = res.bandar;
                    this.form_profil.lkp_jenis_alamat_id = 1;
                    this.form_profil.jabatan_id = 1;
                });
        },
        profil() {
            this.dialogProfil.show = 1;
        },

        // getData(){
        //   alert()
        // },

        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },

        pilihProfil(dt) {
            //   // alert('asds');
            this.form.profil_keterangan = dt.label;
            this.form_cari.id = dt.value;
            this.profilDetail();
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_deposit + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.form.profil_id = res.id;
                    this.form.no_id = res.no_id;
                    this.form.kategori = res.kategori;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                });
        },
        akaunDetail() {
            // alert('asds');
            this.$zcomm
                .get(
                    this.service_deposit +
                        "lookup/akaun_detail/" +
                        this.form.akaun_id
                )
                .then((res) => {
                    this.form_akaun.kod = res.kod;
                    this.form.keterangan = res.kod+ ' | ' +res.keterangan;
                    this.form_akaun.aras_akhir = res.aras_akhir;
                });
        },

        getAkauns() {
            this.$zcomm.get(this.service_deposit+'lookup/akaun_akhir').then(res => {
                  this.akauns = res;
                });
        },


        getJenis(form){
        
            if(form.ind_deposit_jenis_id == 0){
                    form.ind_deposit_jenis_id = 1
            }else{
                form.ind_deposit_jenis_id = 0
            }
            for (var a in this.akauns) {
                if(form.akaun_id == this.akauns[a].value){
                    form.lkp_deposit_jenis_id = this.akauns[a].deposit_jenis;
                }
            }
         },

        jenisButiranDetail() {
        
            this.butiranJenis =[];
            this.$zcomm.get(this.service_deposit+'lookup/jenis_butiran/'+this.form.lkp_deposit_jenis_id).then(res => {
                  this.butiranJenis = res;
                });
        },

        submitDeposit() {
            this.form.lkp_deposit_status_id = 3;
            // alert(this.form.amaun_deposit)
            this.$zcomm
                .post(this.resourceurl, this.form)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya Daftar");
                    this.$inertia.visit(this.$route("deposit.show", res.id));
                    this.upload(res.id);
                    // this.$inertia.visit(this.$route('deposit.index'))
                })
                .catch((err) => {})
                .finally(() => {
                    // <inertia-link :href='$route("deposit.show",item.id)'>
                    this.$inertia.visit(this.$route("deposit.show", res.id));
                });
        },

        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\Deposit");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya Daftar");
                    this.$inertia.visit(this.$route("deposit.show", res.id));
                })
                .catch((err) => {})
                .finally(() => {});
        },


        

         submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_deposit+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
    


    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
        "form.akaun_id": function (q) {
            this.akaunDetail();
        },
        "form.lkp_deposit_jenis_id": function (q) {
            this.jenisButiranDetail();
        },
    },
    mounted() {
        this.dialog.width = 900;
        this.getAkauns();
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
